import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  const guideLinks = [
    { name: "What Is Sugargoo Spreadsheet", slug: "what-is-sugargoo-spreadsheet" },
    { name: "How to Use Spreadsheet", slug: "how-to-use-sugargoo-spreadsheet" },
    { name: "Beginner Mistakes to Avoid", slug: "beginner-mistakes-sugargoo-spreadsheet" },
    { name: "Why Use Spreadsheets", slug: "why-people-use-spreadsheets" },
    { name: "Sugargoo vs Pandabuy", slug: "sugargoo-vs-pandabuy-spreadsheet" },
    { name: "Sugargoo vs CSSBuy", slug: "sugargoo-vs-cssbuy-spreadsheet" },
    { name: "Is Sugargoo Safe?", slug: "is-sugargoo-safe" },
    { name: "Customs Seizure Guide", slug: "customs-seizure-avoidance-guide" },
  ];

  const findsLinks = [
    { name: "Best Finds 2026", slug: "best-sugargoo-spreadsheet-finds-2026" },
    { name: "Top 20 Sneakers", slug: "top-sneakers-sugargoo-spreadsheet" },
    { name: "Best Clothing Items", slug: "best-clothing-sugargoo-spreadsheet" },
    { name: "Luxury Bags Guide", slug: "luxury-bags-spreadsheet-guide" },
    { name: "Cheapest Items", slug: "cheapest-items-sugargoo-spreadsheet" },
  ];

  const topCategories = categories.slice(0, 7);
  const moreCategories = categories.slice(7, 14);

  return (
    <footer className="bg-primary-800 text-background-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-16 md:py-20">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-5 cursor-pointer">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-store-2-line text-background-50 text-base"></i>
              </div>
              <span className="font-heading text-lg font-bold text-background-50 whitespace-nowrap">
                Sugargoo Spreadsheet
              </span>
            </Link>
            <p className="text-background-300 text-sm leading-relaxed mb-4">
              Your trusted directory for curated Sugargoo spreadsheet finds. Browse categories, read guides, and shop smarter.
            </p>
            <Link
              to="/guide/how-to-use-sugargoo-spreadsheet"
              className="inline-flex items-center gap-1.5 text-sm text-primary-300 hover:text-primary-200 transition-colors cursor-pointer"
            >
              <i className="ri-book-open-line text-sm"></i>
              Shopping Guide
            </Link>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              SEO Guides & Comparisons
            </h4>
            <ul className="space-y-2.5">
              {guideLinks.map((link) => (
                <li key={link.slug}>
                  <Link
                    to={`/guide/${link.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              Finds & Recommendations
            </h4>
            <ul className="space-y-2.5">
              {findsLinks.map((link) => (
                <li key={link.slug}>
                  <Link
                    to={`/guide/${link.slug}`}
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              Top Categories
            </h4>
            <ul className="space-y-2.5">
              {topCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4 mt-6">
              More Categories
            </h4>
            <ul className="space-y-2.5">
              {moreCategories.map((cat) => (
                <li key={cat.name}>
                  <a
                    href={cat.url}
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-primary-500/50 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-400">
            &copy; 2026 Sugargoo Spreadsheet Directory. All rights reserved.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
              Visit Main Site
            </a>
            <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
              Home
            </Link>
            <Link to="/guide/how-to-use-sugargoo-spreadsheet" className="text-sm text-background-300 hover:text-background-50 transition-colors cursor-pointer">
              Shopping Guide
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}